import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config";
import { Redirect } from 'react-router-dom';
import { ToastContainer,toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom.min.js';

const PostTestExam = () => {

  const { trainingId, count } = useParams();

  const [questions,setQuestions] = useState([]);
  const [answers,setAnswers] = useState({});

  const [loading, setLoading] = useState(false);

  const history = useHistory();

  useEffect(()=>{
    fetchQuestions();
  },[]);



  const fetchQuestions = async () => {
  try {

    const res = await axios.get(
      `${API_BASE_URL}/pre-test/${trainingId}/${count}`,
      {
        headers:{
          Authorization:`Bearer ${localStorage.getItem("authToken")}`
        }
      }
    );

    // console.log("Questions API:", res.data);

    setQuestions(res.data.data  || []); // correct

  } catch(err){
    toast.error("Failed to load questions");
  }
};

const handleChange = (questionId, value, type) => {

  // Radio / Yes-No (single select)
  if (type === 1 || type === 2) {
    setAnswers(prev => ({
      ...prev,
      [questionId]: [value]   // store as array
    }));
  }

  // Multiple choice
  else if (type === 3 || type === 4) {

    const existing = answers[questionId] || [];

    if (existing.includes(value)) {
      setAnswers(prev => ({
        ...prev,
        [questionId]: existing.filter(v => v !== value)
      }));
    } else {
      setAnswers(prev => ({
        ...prev,
        [questionId]: [...existing, value]
      }));
    }
  }
};

  const handleSubmit = async(e)=>{

  e.preventDefault();

  // validation
  if(Object.keys(answers).length !== questions.length){
    toast.error("Please answer all questions");
    return;
  }

   setLoading(true); // start loading

  try{

    await axios.post(
      `${API_BASE_URL}/submit-post-test`,
      {
        training_participate_id:trainingId,
        question_count: questions.length,
        answers:answers
      },
      {
        headers:{
          Authorization:`Bearer ${localStorage.getItem("authToken")}`
        }
      }
    );

    toast.success("Pre Test Submitted");

     setTimeout(()=>{
      history.push("/TrainingParticipateList");
    },2000);

     

  }catch(err){
    toast.error("Submit failed");
     setLoading(false); // enable button again if error
  }

};

   return (
     <>
       <ToastContainer />

<div className="container-fluid">

<div className="card">

<div className="card-header">
<h4>Post Test Exam</h4>
</div>

<div className="card-body">

<form onSubmit={handleSubmit}>

{questions.map((q,index)=>(
<div key={q.ques_id} className="card mb-3 p-3">

<h6>
{index+1}. {q.questions}
</h6>

{q.answers?.map(ans=>{

if(q.answertype===1 || q.answertype===2){

return(
<div key={ans.id}>
<input
 type="radio"
 name={`question_${q.ques_id}`}
 value={ans.id}
 onChange={()=>handleChange(q.ques_id,ans.id,q.answertype)}
/>
 {ans.answer}
</div>
)

}

if(q.answertype===3 || q.answertype===4){

return(
<div key={ans.id}>
<input
 type="checkbox"
 checked={(answers[q.ques_id] || []).includes(ans.id)}
 onChange={()=>handleChange(q.ques_id,ans.id,q.answertype)}
/>
 {ans.answer}
</div>
)

}

})}

</div>
))}

<button className="btn btn-primary" disabled={loading}>
  {loading ? "Submitting..." : "Submit"}
</button>

</form>

</div>

</div>

</div>

   </>
  );

}

export default PostTestExam;